import { Directive, ViewContainerRef, Input } from '@angular/core';

import {NguiOverlayManager, NguiOverlay} from '@ngui/overlay';

@Directive({
  selector: '[ngui-tooltip]',
  host: {
    '(mouseover)': 'showTooltip($event)',
    '(mouseout)': 'hideTooltip($event)'
  }
})
export class NguiTooltipDirective {

  @Input('ngui-tooltip') tooltip: string;

  el: HTMLElement;
  overlay: NguiOverlay;

  constructor(
    public viewContainerRef: ViewContainerRef,
    public overlayManager: NguiOverlayManager
  ) {
    this.el = this.viewContainerRef.element.nativeElement;
  }

  ngAfterViewInit(): void {
    this.overlay = this.getTooltipOverlay(this.el, this.tooltip);
  }

  showTooltip($event) {
    this.overlayManager.open(this.overlay, $event);
    $event.stopPropagation();
  }

  hideTooltip($event) {
    this.overlayManager.close(this.overlay);
    $event.stopPropagation();
  }

  getTooltipOverlay(el, tooltip) {
    let tooltipEl = document.createElement('ngui-tooltip');
    tooltipEl.style.display = 'none';
    let divEl = document.createElement('div');
    divEl.innerHTML = `
       <div class='tooltip-contents'>${tooltip}</div>
       <div class='tooltip-down-arrow'></div>
    `;
    tooltipEl.appendChild(divEl);

    //el.parentElement.insertBefore(tooltipEl, el.nextSibling);
    el.appendChild(tooltipEl);

    let overlay = new NguiOverlay(tooltipEl, {
      id: 'tooltip-' + (el.id || Math.floor(Math.random()*1000000)),
      position: 'top cursor outside'
    });
    this.overlayManager.register(overlay);
    return overlay;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/strip-loader/lib?strip[]=debug,strip[]=console.log!./src/tooltip-directive.ts